import {HttpCrudDataSource, HttpCrudParams} from '../../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../../core/data-source/json.mapper';
import {httpService} from '../../../../core/services/http.service';
import {OrderLogRecord} from './order-log.record';

export class OrderLogCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/orders/logs/';

    async listOrderLogs(orderId: number): Promise<OrderLogRecord[]> {
        return httpService.get(this.apiPath + orderId, {params: new HttpCrudParams()}).then((response: any) => {
            return response.data.rows.map((list: OrderLogRecord) => fromJson(OrderLogRecord, list));
        });
    }
}
